module.exports = __webpack_public_path__ + "static/media/thermoply-sheathing.265a065d.jpg";